module.exports = __webpack_public_path__ + "static/media/zUSDT.9322db9b.png";